import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function AboutUs() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-24 pb-16 md:pt-32 md:pb-20 bg-gradient-to-br from-[#009E81] via-[#008570] to-[#006D5A] text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(at_bottom_right,#ffffff15_0%,transparent_50%)]" />
        
        <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold tracking-tight mb-6">
            About Sweet Plate
          </h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-2xl mx-auto">
            Redefining food delivery for your city — faster, smarter, and more delicious.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="prose prose-lg text-gray-600 leading-relaxed">
            <p className="text-xl md:text-2xl text-gray-800 font-light mb-12">
              Sweet Plate is redefining food delivery with a smarter, faster model built for your city.
            </p>

            <div className="space-y-8 text-[17px]">
              <p>
                As a first-of-its-kind <span className="font-semibold text-[#009E81]">cloud kitchen network</span>, 
                we don’t rely on multiple restaurants — we operate our own city kitchens to ensure speed, 
                consistency, and full quality control.
              </p>
              
              <p>
                This means <span className="font-medium">no delays, no surprises</span>, just reliable meals 
                delivered quickly. By streamlining operations and focusing on high-demand dishes, we keep costs low 
                and pass the savings directly to you.
              </p>

              <div className="bg-[#F0FBF8] border border-[#009E81]/10 rounded-3xl p-8 md:p-12 my-12">
                <p className="italic text-center text-lg leading-relaxed text-gray-700">
                  The result? Affordable, great-tasting food delivered fast, every time.
                </p>
              </div>

              <p>
                Sweet Plate is built for people who want <span className="font-semibold">convenience without compromise</span> — 
                simple ordering, dependable service, and a food experience you can trust.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="bg-[#F0FBF8] py-16 md:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
            <div className="bg-white rounded-3xl p-8 shadow-sm">
              <div className="w-12 h-12 bg-[#009E81] text-white rounded-2xl flex items-center justify-center mb-6 text-2xl">⚡</div>
              <h3 className="text-2xl font-semibold mb-3">Lightning Fast</h3>
              <p className="text-gray-600">Our own kitchens + smart logistics = meals at your door in minutes, not hours.</p>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-sm">
              <div className="w-12 h-12 bg-[#009E81] text-white rounded-2xl flex items-center justify-center mb-6 text-2xl">✅</div>
              <h3 className="text-2xl font-semibold mb-3">Consistent Quality</h3>
              <p className="text-gray-600">Full control over ingredients and preparation means every order tastes exactly as expected.</p>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-sm">
              <div className="w-12 h-12 bg-[#009E81] text-white rounded-2xl flex items-center justify-center mb-6 text-2xl">💰</div>
              <h3 className="text-2xl font-semibold mb-3">Truly Affordable</h3>
              <p className="text-gray-600">No middlemen markup. We cut costs and give you better value on every order.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
          <div className="inline-flex items-center gap-2 bg-[#F0FBF8] text-[#009E81] px-5 py-2 rounded-full text-sm font-medium mb-6">
            Our Promise
          </div>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-8">
            Joy delivered to your doorstep
          </h2>
          <p className="text-xl text-gray-600">
            The future of taste, trust &amp; technology — built right here in your city.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}